import {HttpClient} from "@angular/common/http";
import {inject, Service} from "@angular/core";
import type {IJsonObject} from "dcerialize";
import {Deserialize} from "dcerialize";
import type {Observable} from "rxjs";
import {map} from "rxjs";
import type {IPaginated, IPaginationQuery} from "../../models/IPaginated";
import type {FeaturedReference, Reference} from "../../models/Reference/Reference";
import {References} from "../../models/Reference/References";
import {BaseApiService} from "./base-api.service";

@Service()
export class ReferencesService extends BaseApiService {
  private readonly http = inject(HttpClient);

  public constructor() {
    super("references");
  }

  public getAllReferences(paginationQuery?: IPaginationQuery): Observable<IPaginated<Reference>> {
    const params = this.httpParamsFromPaginationQuery(paginationQuery);
    return this.http.get<IJsonObject>(this.getEndpointUrl(), {params})
      .pipe(map(m => Deserialize(m, () => References<Reference>)));
  }

  public getFeaturedReferences(paginationQuery?: IPaginationQuery): Observable<IPaginated<FeaturedReference>> {
    const params = this.httpParamsFromPaginationQuery(paginationQuery);
    return this.http.get<IJsonObject>(this.getEndpointUrl("featured"), {params})
      .pipe(map(m => Deserialize(m, () => References<FeaturedReference>)));
  }
}
